import {createPinia, mapStores} from "pinia";
import {createApp} from "vue";
import config from '@/config/config';
import axios from 'axios';
import router from '@/router';
import App from "@/App.vue";

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import 'popper.js';
import '@/assets/css/global.css';

import {Loading, MessageBox} from "@/store";

const store = createPinia();
const app = createApp(App);

axios.defaults.validateStatus = () => true;
app.config.globalProperties.$config = config;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$api = axios.create({
    baseURL: config.apiUrl,
    headers: {
        'content-type': 'application/json'
    }
});


store.use(({ store }) => {
    store.$api = app.config.globalProperties.$api;
});

app.use(router)
app.use(store);
app.config.globalProperties.$Loading = Loading();
app.config.globalProperties.$MessageBox = MessageBox();
app.mount("#app");
